// src/actions/ContactoActions.js
import apiClient from '../api/apiClient';

// Obtener todos los contactos por entidad ID
export const obtenerContactosPorEntidad = async (entidadId) => {
  try {
    const response = await apiClient.get(`/contactos/entidad/${entidadId}`);
    return response;
  } catch (error) {
    console.error('Error obteniendo contactos por entidad:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al obtener contactos" }
    };
  }
};

// Crear un nuevo contacto
export const crearContacto = async (contactoData) => {
  try {
    const response = await apiClient.post('/contactos', contactoData);
    return response;
  } catch (error) {
    console.error('Error creando contacto:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al crear contacto" }
    };
  }
};

// Actualizar un contacto existente
export const actualizarContacto = async (contactoId, contactoData) => {
  try {
    const response = await apiClient.put(`/contactos/${contactoId}`, contactoData);
    return response;
  } catch (error) {
    console.error('Error actualizando contacto:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al actualizar contacto" }
    };
  }
};

// Eliminar un contacto
export const eliminarContacto = async (contactoId) => {
  try {
    const response = await apiClient.delete(`/contactos/${contactoId}`);
    return response;
  } catch (error) {
    console.error('Error eliminando contacto:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al eliminar contacto" }
    };
  }
};

// Obtener todos los cargos disponibles
export const obtenerCargos = async () => {
  try {
    const response = await apiClient.get('/cargos');
    return response;
  } catch (error) {
    console.error('Error obteniendo cargos:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al obtener cargos" }
    };
  }
};

// Obtener un contacto por ID
export const obtenerContactoPorId = async (contactoId) => {
  try {
    const response = await apiClient.get(`/contactos/${contactoId}`);
    return response;
  } catch (error) {
    console.error('Error obteniendo contacto por ID:', error);
    return error.response || {
      status: 500,
      data: { message: "Error de conexión al obtener contacto" }
    };
  }
};